
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(3 3)"}},[_c('path',{attrs:{"d":"M41.946 25.871a4 4 0 013.994-4.204h2.177a4 4 0 013.995 4.213l-1.378 25.788a3.738 3.738 0 01-7.466-.008l-1.322-25.79zm5.087 46.464c-1.672 0-3.058-.526-4.156-1.577-1.1-1.099-1.649-2.436-1.649-4.013s.55-2.89 1.649-3.942c1.098-1.05 2.484-1.576 4.156-1.576 1.625 0 2.962.525 4.014 1.576 1.099 1.051 1.648 2.365 1.648 3.942 0 1.576-.55 2.914-1.648 4.013-1.051 1.051-2.39 1.577-4.014 1.577z","data-fill-colored":"true"}}),_c('circle',{attrs:{"fill":"none","stroke-width":"6","cx":"47","cy":"47","r":"47"}})])])
          )
        }
      }
    